import React from "react";

import { Controller, useFormContext } from "react-hook-form";

import TextField from "./TextField";

interface FormCellTextFieldProps {
  name: string;
  defaultValue?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  containerClassName?: string;
  inputClassName?: string;
  maxLength?: number;
  placeholder?: string;
  inputType?: string;
}

const FormCellTextField: React.FC<FormCellTextFieldProps> = ({
  name,
  defaultValue = "",
  inputType,
  ...rest
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => (
        <>
          <TextField {...field} {...rest} inputType={inputType} />
          {error && <span style={{ color: "red" }}>{error.message}</span>}
        </>
      )}
    />
  );
};

export default FormCellTextField;
